export default __webpack_public_path__ + "static/media/benzinga_logo_mobile.a5f81821.png";